import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class CurrencyUtils {
  getCurrencyByLang(lang: string): string {
    switch (lang) {
      case 'pt':
        return 'BRL';
      case 'en':
        return 'USD';
      case 'es':
        return 'EUR';
      case 'it':
        return 'EUR';
      default:
        return 'BRL';
    }
  }
}
